/**
 * A product requires a dental license at three independent levels, and a surface has to
 * OR all three together or it will under-report: the manufacturer/category level comes
 * from the PDP payload (`mpLicenseExist` / `catLicenseExist`), while the two vendor-level
 * switches ride on each vendor option. Sites that checked only the vendor switches used
 * to hide the badge on products whose requirement is manufacturer- or category-wide.
 */

/** Manufacturer- or category-level license requirement from the PDP payload. */
export function productDetailsRequireLicense(details?: ProductDetails | null): boolean {
  return Boolean(details?.mpLicenseExist || details?.catLicenseExist);
}

/** Full rule: manufacturer/category OR vendor-vertical OR vendor-product level. */
export function licenseIsRequired(
  vendorOption?: VendorOptionState | null,
  manufacturerOrCategoryRequired?: boolean,
): boolean {
  return Boolean(
    manufacturerOrCategoryRequired ||
    vendorOption?.vendorVerticalLevelLicenseRequiredSw ||
    vendorOption?.vendorProductLevelLicenseRequiredSw,
  );
}
